import { createApp } from 'vue'
import SuccessPage from './SuccessPage'

const el = '.kb-component--success-page'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SuccessPageDOM) => {
            const component = createApp(SuccessPage).use(Store)
            component.mount(SuccessPageDOM)
        })
    }
}
